import React, { useMemo } from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './components/MainLayout'; // Import the layout component
import AdminDashboard from './components/AdminDashboard'; // Import admin dashboard
import { ThemeProvider, CssBaseline } from '@mui/material';
import { useThemeMode } from './contexts/ThemeContext';
import { buildTheme } from './theme';

function App() {
  const { isDark } = useThemeMode();
  // Single source of truth - see src/theme.ts.
  const theme = useMemo(() => buildTheme(isDark), [isDark]);
  return (
    <ThemeProvider theme={theme}> { /* ThemeProvider might still be useful here */ }
      <CssBaseline />
      <Routes>
        {/* Public Route: Login Page */}
        <Route path="/login" element={<Login />} />

        {/* Admin Route: Admin Dashboard (no protection, uses its own auth) */}
        <Route path="/admin" element={<AdminDashboard />} />

        {/* Protected Routes: Main application layout */}
        <Route element={<ProtectedRoute />}>
          <Route path="/*" element={<MainLayout />} /> { /* Catch-all for protected area */}
          {/* Add more specific protected routes inside if needed, e.g., */}
          {/* <Route path="/settings" element={<SettingsPage />} /> */}
        </Route>

        {/* Optional: Add a 404 Not Found route */}
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </ThemeProvider>
  );
}

export default App;
